/**
 * Attribute the root route puts on <html> in the prerendered SPA shell
 * (`/_shell.html`) only. The client entry (src/client.tsx) checks it before
 * React starts, to render the page instead of hydrating it.
 */
export const SPA_SHELL_ATTRIBUTE = 'data-spa-shell'

let rendered = false

/** Called by the client entry when it rendered the shell instead of hydrating. */
export const markShellRendered = () => {
  rendered = true
}

/** Whether this page load rendered the shell (React rebuilt <html> and <head>). */
export const shellWasRendered = () => rendered
